/**
 * @surfline/web-common v11.3.3 2020-12-28
 */

import slugify from '../slugify/slugify.js';

/**
 * @description Given a name and id, creates a path to a spot report page.
 * @param {string} name Name or slug for the spot report
 * @param {*} id _id of the spot
 * @param {*} [shouldSlugify=false] optional parameter to slugify the `name` that is passed in
 */

var spotReportPath = function spotReportPath(name, id) {
  var shouldSlugify = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return `/surf-report/${shouldSlugify ? slugify(name) : name}/${id}`;
};
/**
 * @description Given a slug and ID, returns the path to the subregion forecast
 * @param {string} slug
 * @param {string} id
 * @returns {string}
 */


var subregionForecastPath = function subregionForecastPath(slug, id) {
  return `/surf-forecasts/${slug}/${id}`;
};
/**
 * @description Given a slug and ID, returns the path to the subregion charts
 * @param {string} slug
 * @param {string} id
 * @returns {string}
 */


var subregionForecastChartsPath = function subregionForecastChartsPath(slug, id) {
  return `/surf-forecasts/${slug}/${id}/charts`;
};
/**
 * @description Given a slug and ID, returns the path to the subregion premium analysis
 * @param {string} slug
 * @param {string} id
 * @returns {string}
 */


var subregionPremiumAnalysisPath = function subregionPremiumAnalysisPath(slug, id) {
  return `/surf-forecasts/${slug}/${id}/premium-analysis`;
};
/**
 * @description Given a lat, lon, and zoom returns the path to the map page
 * @param {Object} coords
 * @param {string | number} coords.lat
 * @param {string | number} coords.lon
 * @param {string | number} zoom
 * @returns {string}
 */


var mapPath = function mapPath(_ref, zoom) {
  var lat = _ref.lat,
      lon = _ref.lon;
  return `surf-reports-forecasts-cams-map/@${lat},${lon},${zoom}z`;
};
/**
 * @description Given a slug and GeonameID, returns the path to the geoname map
 * @param {string} slug
 * @param {string} geonameId
 * @returns {string}
 */


var geonameMapPath = function geonameMapPath(slug, geonameId) {
  return `surf-reports-forecasts-cams/${slug}/${geonameId}`;
};
/**
 * @description Given a Spot ID, returns the path to the cam rewind page
 * @param {string} spotId
 * @returns {string}
 */


var camRewindPath = function camRewindPath(spotId) {
  return `https://www.surfline.com/surfdata/video-rewind/video_rewind.cfm?id=${spotId}`;
};
/**
 * @description Given a Cam Alias, returns the path to the cam rewind page
 * @param {string} camAlias
 * @returns {string}
 */


var camRewindPathByAlias = function camRewindPathByAlias(camAlias) {
  return `https://www.surfline.com/surfdata/video-rewind/video_rewind.cfm?camAlias=${camAlias}`;
};

var kbyg = {
  spotReportPath,
  subregionForecastPath,
  subregionForecastChartsPath,
  subregionPremiumAnalysisPath,
  mapPath,
  geonameMapPath,
  camRewindPath,
  camRewindPathByAlias
};

export default kbyg;
//# sourceMappingURL=kbyg.js.map
